import styled from 'styled-components';

export const StyledTableDataLabel = styled.td<{ textAlignTop?: boolean }>`
  ${({ textAlignTop }) => textAlignTop && 'vertical-align: top;'}
  min-width: 150px;
`;

export const StyledTableDataContents = styled.td<{ flexCol?: boolean }>`
  ${({ flexCol }) =>
    flexCol &&
    `
      display: flex;
      flex-direction: column;
    `}
  min-width: 200px;
`;
